import Grid from "@mui/material/Grid";
import React, { useRef, useEffect, useState } from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useMsal } from "@azure/msal-react";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

function Theproblem() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userRoles = activeAccount?.idTokenClaims?.roles || [];
  const iframeRef = useRef(null);
  const containerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const [selectedRole, setSelectedRole] = useState(
    localStorage.getItem("selectedRole") || userRoles[0] || ""
  );

  useEffect(() => {
    const storedRole = localStorage.getItem("selectedRole");
    if (storedRole && selectedRole !== storedRole) {
      setSelectedRole(storedRole);
    }
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        bgColor="rgba(148, 148, 148, 0.07)"
        borderRadius="lg"
        shadow="md"
        p={{ xs: 2, sm: 4 }}
        m={{ xs: 2, sm: 4 }}
        sx={{
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.36)",
          backdropFilter: "blur(8px)",
        }}
      >
        <MDBox mb={3} textAlign="left">
          <h1 style={{ color: "white", fontSize: "32px", marginBottom: "16px" }}>The Problem</h1>
          <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "white" }}>
            Subsea Leaks: A Colossal Risk for Subsea Production Systems
          </h2>
        </MDBox>

        <Grid container spacing={4}>
          {[
            {
              title: "Financial Setbacks",
              points: [
                "Environmental damage leading to millions in fines",
                "Clean-up costs",
                "Litigation fees and liabilities",
                "Loss of production",
              ],
            },
            {
              title: "Extensive Legal Implications",
              points: [
                "Government and commercial lawsuits lasting years",
                "Potential costs reaching millions of dollars",
              ],
            },
            {
              title: "Irreparable Reputation Damage",
              points: [
                "Loss of confidence as a reputable operator in the oil sector",
                "Risk of losing production rights",
                "Increased regulatory scrutiny",
              ],
            },
            {
              title: "Unknown Time Frame of Halted Production",
              points: ["Regulatory fines or production halt"],
            },
          ].map((card, index) => (
            <Grid item xs={12} sm={6} md={6} lg={3} key={index}>
              <MDBox
                bgColor="dark"
                borderRadius="md"
                p={3}
                height="100%"
                variant="gradient"
                sx={{ color: "white" }}
              >
                <h3 style={{ fontSize: "20px", fontWeight: "bold", color: "white" }}>
                  {card.title}
                </h3>
                <ul
                  style={{
                    fontSize: "16px",
                    paddingLeft: "20px",
                    marginTop: "12px",
                    color: "white",
                  }}
                >
                  {card.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </MDBox>
            </Grid>
          ))}
        </Grid>
      </MDBox>

      {/* Case Study Video Section */}
      <MDBox
        ref={containerRef}
        bgColor="rgba(148, 148, 148, 0.07)"
        borderRadius="lg"
        p={isFullscreen ? 0 : 3}
        mt={isFullscreen ? 0 : 4}
        mx={isFullscreen ? 0 : "auto"}
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          width: isFullscreen ? "100vw" : "100%",
          // height: isFullscreen ? "100vh" : "80vh",
          maxWidth: isFullscreen ? "none" : "1400px",
          boxShadow: isFullscreen ? "none" : "0px 8px 20px rgba(0, 0, 0, 0.36)",
          backdropFilter: "blur(8px)",
          overflow: "hidden",
          position: isFullscreen ? "relative" : "static",
          backgroundColor: isFullscreen ? "#000" : "rgba(148, 148, 148, 0.07)",
        }}
      >
        <h2
          style={{
            fontSize: "26px",
            fontWeight: "bold",
            marginBottom: "16px",
            color: "white",
          }}
        >
          Subsea Leak Case Study Video
        </h2>

        <video
          width="100%"
          height="auto"
          controls
          autoPlay
          playsInline
          controlsList="nodownload"
          style={{
            display: "block",
            margin: "0 auto",
            backgroundColor: "black",
            borderRadius: "12px",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            border: "none",
          }}
        >
          <source
            src="https://teslasubsea.com/wp-content/uploads/2025/05/720p-Glider-Case-Study.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </MDBox>
    </DashboardLayout>
  );
}

export default Theproblem;
